<script setup>
import OlympiadsProvider from './OlympiadsProvider.vue';
import GameDashProvider from '/app/components/game-dash/Provider.vue';
import PlatformProvider from './PlatformProvider.vue';
import UserBanProvider from './UserBanProvider.vue';
import UserBanPopover from '/app/components/moderation/user-ban-popover.vue';
import ModerationContext from '/app/components/moderation/ModerationContext.vue';
import DebugProvider from './DebugProvider.vue';
import { usePlatform } from '/app/composables/platform';
import { useAuth } from '/app/composables/auth';

const { auth: $auth } = useAuth();
const { contextPlatform } = usePlatform();

const platformActions = [
    'game.challenge.create',
    'chat.topic.create',
    'account.profile.edit',
    'notification.dailydigest',
];
</script>

<template>
    <DebugProvider>
        <PlatformProvider>
            <UserBanProvider>
                <ModerationContext context="platform" :id="contextPlatform?.id" :actions="platformActions">
                    <OlympiadsProvider :platform="$auth.user.screen_name">
                        <GameDashProvider>
                            <div class="app-wrapper">
                                <slot />
                            </div>
                        </GameDashProvider>
                    </OlympiadsProvider>
                </ModerationContext>
            </UserBanProvider>
        </PlatformProvider>
    </DebugProvider>
</template>